import React, { FC, useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Accordion, Box, Button, AccordionDetails, AccordionSummary, CircularProgress, Tooltip, Typography, useTheme, useMediaQuery } from "@mui/material";
import { WidgetContext } from "../../contexts/WidgetContext";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import styles from "../../content/pages/homepage.module.css";
import LoginForm from "../LoginForm/LoginForm";
import { postUserPreferences } from "src/api/postUserPreferences";
import { useAbortController } from "src/utils/useAbortController";
import { getValidYahooTokenfromBack } from "src/api/getValidYahooToken";
import { useAuth0 } from "@auth0/auth0-react";
import { getUserLeagues } from "src/api/getUserLeagues";
import { loginFantasyPlatform } from "src/api/loginFantasyPlatform";
import TeamsDropdown from "../PlatformSelector/TeamsDropdown";
import PlatformDropdown from "../LoginForm/PlatformDropdown";
import PlatformSelector from "../PlatformSelector/PlatformSelector";
import { LeagueSelectorProps } from "src/mockup/leagueSelectorProps";
import { useSafeAccessAuth0Token } from "src/hooks/useSafeAccessAuth0Token";
import { trackPlatformLogin } from "src/utils/analyticsCapFirebase";
import { sendEspnCode } from "src/api/sendEspnCode";
import { loginEspnPlatform } from "src/api/loginEspnPlatform";
import { getUserLeaguesEspn } from "src/api/getUserLeaguesEspn";
import RefreshIcon from "@mui/icons-material/Refresh";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import SegmentedSpinner from "../Loader/SegmentedProgress";
import { isMobileWebBrowser, mobile } from "src/utils/platformUtils";
import { ReactComponent as EditIcon } from "src/assets/EditIcon.svg";
import HistoryIcon from '@mui/icons-material/History';
import LeagueSettings from "./LeagueSettings";
import AutoProcessAISwitch from "./AutoProcessAISwitch";
import KeeperDrawer, { KeeperFormData } from "../KeeperDrawer/KeeperDrawer";
import HistoryDrawer from "../HistoryDrawer/HistoryDrawer";
import { savePlatformPermission } from "src/api/platformPermission";
import { checkMaliciousNotes } from "src/api/checkMaliciousNotes";
import { extractKeeperData, injectKeeperData, mapLeagueInfoToCalculatorSettings } from "src/utils/keeperNotes.utils";
import { fetchUserRequestHistory, UserRequestHistoryItem } from "src/api/fetchUserRequestHistory";
import { isUnsyncedPlatform, UNSYNCED_PLATFORM_ID } from "src/constants/unsyncedLeague";
import { Capacitor } from "@capacitor/core";

const LeagueSelector: React.FC<LeagueSelectorProps> = ({
  expanded,
  setExpanded,
  setIsAddIcon,
  isSpeedDialOpen,
  setIsSpeedDialOpen,
  hasTeams,
  teamsData,
  setTeamsdata,
  isChangingPlatform,
  setIsChangingPlatform,
  isYahooSelected,
  setYahooToken,
  shakingPlatform,
  setShakingPlatform,
  deletionMode,
  setDeletionMode,
  setLoadingNews,
  setLoadingWaiver,
  setLoadingStart,
  setLoadingRoster,
  setLoadingRankings,
  setLoadingAllRankings,
  setLoadingRundown,
  setLoadingDraftAdvice,
  setHasLoadingStarted,
  setWaiverData,
  setNewsData,
  setStartData,
  setRostersData,
  setRankingsData,
  setAllRankingsData,
  setRundownData,
  setDraftAdviceData,
  setEndpointErrors,
  fetchNewsData,
  fetchWaiverData,
  fetchWaiverDataStream,
  fetchStartDataStream,
  fetchRostersData,
  fetchRankingsData,
  fetchAllRankingsData,
  fetchRundownDataStream,
  fetchDraftAdviceDataStream,
  handleLeagueId,
  handlePartnerSelected,
  handlePlatformLongPress,
  userDataPlatform,
  teamsHomePageRef,
  setErrorMessages,
  fetchSuperFunctionData,
  setLoadingSuperFunction,
  commonLeagueDataFailed,
  setCommonLeagueDataFailed,
  returnedFromBackground,
  setReturnedFromBackground,
  isHandlingTeamSelection,
  newClickOnPlatofrm,
  setNewClickOnPlatofrm,
  setErrorMessageNoDraft,
  setWaiverStreamState,
  setStartStreamState,
  setRundownStreamState,
  setDraftAdviceStreamState,
  setThoughtsCommon,
  isSuperAnalysisComplete,
  setIsSuperAnalysisComplete,
  setSummaryAudios,
  hasAudioBeenPlayed,
  forceRefresh,
  setForceRefresh,
  refreshingLeagueData,
  setRefreshingLeagueData,
  activeRequests,
  setEstimatedTimes,
  activeStreamRequests,
  calculatorSettings,
  setCalculatorSettings,
  leagueSettingsChanged,
  setLeagueSettingsChanged,
  selectedModel,
  userSubscription,
  characterRef,
  enableCreditValidation,
  setIsBenchDrawerOpen,
  setIsPaymentOpen,
  setInitialPaymentView,
  openRateLimitDrawer,
}) => {
  const {
    selectedPartner,
    setSelectedPartner,
    pocToken,
    leaguePlatforms,
    setLeaguePlatforms,
    setMessage,
    teamsDataCache,
    setTeamsDataCache,
    userDataCache,
    setUserDataCache,
    sectionData,
    setSectionData,
    selectedTeams,
    setSelectedTeams,
    selectedTeamInfo,
    setSelectedTeamInfo,
    yahooToken,
    setLeagueIdPlatform,
    getValidYahooToken,
    cancelPendingRequests,
    allowedPlatforms,
    setIsYahooLoading,
    setCurrentAbortController,
    lastUpdatedTimestamps,
    setLastUpdatedTimestamps,
    updateButtonProgress,
    getButtonProgress,
    forceSavePreferences,
    aiSettings,
    isLoggedInAuth0ExperienceGlobal,
    keeperDrawerSeenMap,
    setKeeperDrawerSeenMap,
    isLoadingPreferences,
  } = useContext(WidgetContext);

  const [loggingInTo, setLoggingInTo] = useState(null);
  const [loginError, setLoginError] = useState(null);
  const [isKeeperDrawerOpen, setIsKeeperDrawerOpen] = useState(false);
  const [isKeeperSubmitting, setIsKeeperSubmitting] = useState(false);
  const leagueSettingsAccordionRef = useRef<HTMLDivElement>(null);
  const keeperAutoOpenTriggeredRef = useRef<string | null>(null);

  // Ref to save the timestamp (in milliseconds) of the last time the leagues were fetched by platform
  const teamsDataFetchTimestamps = useRef<Record<string, number>>({});
  // Latest platform click — stale getUserLeagues must not paint another platform's teams
  const platformSelectRequestIdRef = useRef<string | null>(null);

  const [backdropTop, setBackdropTop] = useState<number>(0);
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);
  // Track if we need to show success icon after super_analysis completes
  const pendingSaveSuccessRef = useRef<boolean>(false);
  // History icon → user_request_history in flight (swap icon for spinner)
  const [isFetchingHistory, setIsFetchingHistory] = useState(false);
  const [isHistoryDrawerOpen, setIsHistoryDrawerOpen] = useState(false);
  const [historyItems, setHistoryItems] = useState<UserRequestHistoryItem[]>([]);

  /* Dynamic accordion height: measure from accordion top to viewport bottom.
   * Adapts to Quan on/off, resize, etc. Initial value = fallback for first paint before measure. */
  const teamsAccordionDetailsRef = useRef<HTMLDivElement>(null);
  const [teamsMaxHeight, setTeamsMaxHeight] = useState<string>("50vh");

  const platformAccordionDetailsRef = useRef<HTMLDivElement>(null);
  const [platformMaxHeight, setPlatformMaxHeight] = useState<string>("50vh");

  const leagueSettingsAccordionDetailsRef = useRef<HTMLDivElement>(null);
  const [leagueSettingsMaxHeight, setLeagueSettingsMaxHeight] = useState<string>("50vh");

  const measureAccordionHeight = (
    el: HTMLElement | null,
    setHeight: (h: string) => void
  ) => {
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pad = 0;
    const h = Math.max(100, window.innerHeight - rect.top - pad);
    setHeight(`${h}px`);
  };

  // Teams accordion: run when panel1 opens; re-run when Quan toggles (layout shift)
  useLayoutEffect(() => {
    if (expanded !== "panel1") return;
    const measure = () => measureAccordionHeight(teamsAccordionDetailsRef.current, setTeamsMaxHeight);
    measure();
    requestAnimationFrame(measure);
    const ro = new ResizeObserver(measure);
    const el = teamsAccordionDetailsRef.current;
    if (el) ro.observe(el);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [expanded, aiSettings?.quan]);

  // Platform accordion: same logic for panel0
  useLayoutEffect(() => {
    if (expanded !== "panel0") return;
    const measure = () => measureAccordionHeight(platformAccordionDetailsRef.current, setPlatformMaxHeight);
    measure();
    requestAnimationFrame(measure);
    const ro = new ResizeObserver(measure);
    const el = platformAccordionDetailsRef.current;
    if (el) ro.observe(el);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [expanded, aiSettings?.quan]);

  // League Settings accordion: same logic for panel2 (single scroll container, fixes iOS bounce)
  useLayoutEffect(() => {
    if (expanded !== "panel2") return;
    const measure = () => measureAccordionHeight(leagueSettingsAccordionDetailsRef.current, setLeagueSettingsMaxHeight);
    measure();
    requestAnimationFrame(measure);
    const ro = new ResizeObserver(measure);
    const el = leagueSettingsAccordionDetailsRef.current;
    if (el) ro.observe(el);
    window.addEventListener("resize", measure);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [expanded, aiSettings?.quan]);

  const isMobile = isMobileWebBrowser() || mobile;

  // Calculate backdrop position when accordion opens
  useEffect(() => {
    if (expanded === "panel2" && leagueSettingsAccordionRef.current) {
      const updateBackdropTop = () => {
        if (leagueSettingsAccordionRef.current) {
          const rect = leagueSettingsAccordionRef.current.getBoundingClientRect();
          setBackdropTop(rect.top);
        }
      };

      updateBackdropTop();
      window.addEventListener("scroll", updateBackdropTop);
      window.addEventListener("resize", updateBackdropTop);

      return () => {
        window.removeEventListener("scroll", updateBackdropTop);
        window.removeEventListener("resize", updateBackdropTop);
      };
    }
  }, [expanded]);

  // Reset pending save success when team changes
  useEffect(() => {
    pendingSaveSuccessRef.current = false;
    setShowSaveSuccess(false);
    // setCalculatorSettings(null); // Clear calculator settings when team changes to prevent stale data
  }, [selectedTeamInfo?.platformId, selectedTeamInfo?.leagueId, selectedTeamInfo?.teamName]);

  // const [validToken, setValidToken] = useState<string | null>(null);

  // Ref to create new abort controller
  const { createNewAbortController } = useAbortController();

  const { user } = useAuth0();
  const authId = user?.sub || "unknown";

  const { getSafeAccessAuth0Token } = useSafeAccessAuth0Token();

  //
  const selectedPlatform = leaguePlatforms.find((p) => p.isSelected);
  // Partner/team UI only when it belongs to the currently selected platform (blocks Un-Synced label on Sleeper/MFL)
  const partnerMatchesSelectedPlatform = Boolean(
    selectedPartner && selectedTeamInfo?.platformId && selectedPlatform?.id === selectedTeamInfo.platformId
  );

  // Heal cross-platform stale selection (e.g. Un-Synced handlePartnerClick finishing after switch to MFL/Sleeper)
  useEffect(() => {
    if (!selectedTeamInfo || !selectedPlatform) return;
    if (selectedTeamInfo.platformId === selectedPlatform.id) return;
    setSelectedTeamInfo(null);
    setSelectedPartner("");
    setLeagueIdPlatform("");
  }, [selectedPlatform?.id, selectedTeamInfo?.platformId]);

  // Un-Synced is virtual and always allowed (not in backend allowedPlatforms whitelist)
  const isSelectedPlatformAllowed =
    selectedPlatform && (isUnsyncedPlatform(selectedPlatform.id) || allowedPlatforms?.includes(selectedPlatform.id));
  const isUnsyncedPlatformSelected = Boolean(selectedPlatform && isUnsyncedPlatform(selectedPlatform.id));
  // Synced teams header only: close X sits at the far right (shifts history/edit/refresh left).
  // const syncedTeamsPickerCloseOffset = isUnsyncedPlatformSelected ? 0 : 35;
  const syncedTeamsPickerCloseOffset = isUnsyncedPlatformSelected ? 0 : 0;

  // Derived flag: show edit icon ONLY after both commonLeagueData AND super_analysis finished successfully for the currently selected team.
  // NOTE: Render-only condition (no side effects) to avoid impacting any endpoint flow.
  const isCommonLeagueDataFinished = Boolean(
    selectedTeamInfo &&
    !commonLeagueDataFailed &&
    sectionData?.commonLeagueData?.timestamp &&
    sectionData.commonLeagueData.platform === selectedTeamInfo.platformId &&
    sectionData.commonLeagueData.leagueId === selectedTeamInfo.leagueId &&
    sectionData.commonLeagueData.teamName === selectedTeamInfo.teamName &&
    isSuperAnalysisComplete // Also require super_analysis to be complete
  );

  // Effect to show success icon when BOTH flows complete after Save Changes
  // Only shows CheckCircleIcon if user clicked Save Changes (pendingSaveSuccessRef.current === true)
  useEffect(() => {
    if (pendingSaveSuccessRef.current && isCommonLeagueDataFinished) {
      // Both flows just completed and we have a pending save success from Save Changes
      setShowSaveSuccess(true);
      pendingSaveSuccessRef.current = false;
      setTimeout(() => {
        setShowSaveSuccess(false);
      }, 2000); // Show CheckCircleIcon for 2 seconds, then EditIcon will appear
    }
  }, [isCommonLeagueDataFinished]);

  // This function resets the UI when the selected platform is disabled,
  // inspired by handleLoginCloseYahoo and handlePlatformDeleteClick.
  const cleanupForDisallowedPlatform = () => {
    setSelectedTeamInfo(null);
    setSelectedPartner("");
    setLeagueIdPlatform(null);
    setTeamsdata(null); // This clears the team list from the UI

    // Ensure all loading indicators are off
    setLoadingNews(false);
    setLoadingWaiver(false);
    setLoadingStart(false);
    setLoadingRoster(false);
    setLoadingRankings(false);
    setLoadingAllRankings(false);
    setLoadingRundown(false);
    setLoadingDraftAdvice(false);
    setHasLoadingStarted(false);
  };

  // Effect to automatically clean up state if the selected platform is no longer allowed
  useEffect(() => {
    if (selectedPlatform && !isSelectedPlatformAllowed) {
      cleanupForDisallowedPlatform();
    }
  }, [isSelectedPlatformAllowed, selectedPlatform]);

  // Un-Synced only: after prefs load (web refresh / Capacitor cold start), auto-select first local league
  // and run the same handlePartnerClick path as a manual team click. Other platforms are untouched.
  const unsyncedBootAutoSelectRef = useRef<string | null>(null);
  useEffect(() => {
    if (isLoadingPreferences) return;

    const selected = leaguePlatforms.find((p) => p.isSelected);
    if (!selected || !isUnsyncedPlatform(selected.id)) return;

    const unsyncedTeams = teamsDataCache[UNSYNCED_PLATFORM_ID];
    const firstLeague = unsyncedTeams?.leagues?.[0];
    if (!firstLeague?.league_id || !firstLeague?.name) return;

    // One-shot per mount / league_id
    if (unsyncedBootAutoSelectRef.current === firstLeague.league_id) return;

    // Web: skip when team already set (avoids double handlePartnerClick on Sleeper → Un-Synced).
    // Capacitor remount (Quan/Character): first boot fetch was aborted; hydrate News/Rankings without the 100ms delay.
    // Skip while isChangingPlatform so a live platform switch is not double-fired.
    if (
      selectedTeamInfo?.platformId === UNSYNCED_PLATFORM_ID &&
      selectedTeamInfo?.leagueId === firstLeague.league_id
    ) {
      if (!Capacitor.isNativePlatform() || isChangingPlatform) {
        unsyncedBootAutoSelectRef.current = firstLeague.league_id;
        return;
      }
      if (!pocToken || !teamsHomePageRef?.current?.handlePartnerClick) return;

      unsyncedBootAutoSelectRef.current = firstLeague.league_id;
      setTeamsdata(unsyncedTeams);
      setExpanded("");
      let cancelledHydrate = false;
      (async () => {
        try {
          if (cancelledHydrate || !teamsHomePageRef?.current?.handlePartnerClick) {
            if (unsyncedBootAutoSelectRef.current === firstLeague.league_id) {
              unsyncedBootAutoSelectRef.current = null;
            }
            return;
          }
          await teamsHomePageRef.current.handlePartnerClick(
            firstLeague.name,
            firstLeague.league_id,
            UNSYNCED_PLATFORM_ID,
          );
        } catch (error) {
          console.error("Un-Synced Capacitor remount hydrate failed:", error);
          if (unsyncedBootAutoSelectRef.current === firstLeague.league_id) {
            unsyncedBootAutoSelectRef.current = null;
          }
        }
      })();
      return () => {
        cancelledHydrate = true;
      };
    }

    if (!pocToken || !teamsHomePageRef?.current?.handlePartnerClick) return;

    unsyncedBootAutoSelectRef.current = firstLeague.league_id;

    let cancelled = false;
    (async () => {
      try {
        // Ensure TeamsDropdown local teamsData matches cache (refresh does not call handlePlatformSelectClick)
        setTeamsdata(unsyncedTeams);
        setExpanded("");
        // Capacitor cold start: wait a bit longer for commit + imperative handle readiness
        await new Promise((resolve) => setTimeout(resolve, 100));
        if (cancelled || !teamsHomePageRef?.current?.handlePartnerClick) {
          // Allow a later effect run if handle was not ready (do not leave ref stuck)
          if (unsyncedBootAutoSelectRef.current === firstLeague.league_id) {
            unsyncedBootAutoSelectRef.current = null;
          }
          return;
        }
        await teamsHomePageRef.current.handlePartnerClick(
          firstLeague.name,
          firstLeague.league_id,
          UNSYNCED_PLATFORM_ID,
        );
      } catch (error) {
        console.error("Un-Synced boot auto-select failed:", error);
        if (unsyncedBootAutoSelectRef.current === firstLeague.league_id) {
          unsyncedBootAutoSelectRef.current = null;
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    isLoadingPreferences,
    leaguePlatforms,
    teamsDataCache,
    selectedTeamInfo,
    pocToken,
    teamsHomePageRef,
    setTeamsdata,
    setExpanded,
    isChangingPlatform,
  ]);

  //--------------------------------------------
  // Function to switch the icon of the button platforms
  const handleIconClick = () => {
    setIsSpeedDialOpen(!isSpeedDialOpen);
    if (expanded === "panel0") {
      setIsAddIcon(true);
      // Closing the platform picker returns to the synced teams list (it stays open).
      setExpanded(!isUnsyncedPlatformSelected && hasTeams ? "panel1" : "");
    } else {
      setExpanded("panel0");
      setIsAddIcon(false);
      setMessage("Let's start by connecting to a league");
    }
  };

  // Function to display selected accordion
  const handleChange = (panel: string) => {
    // panel1 toggles only from the header click, and only when a team is already selected.
    // Un-Synced never opens it.
    if (panel === "panel1") return;
    setExpanded((prevPanel) => {
      const next = prevPanel === panel ? "" : panel;
      // No team yet: closing settings must not leave "Select Team" on an empty screen.
      if (next === "" && !isUnsyncedPlatformSelected && hasTeams && !partnerMatchesSelectedPlatform) return "panel1";
      return next;
    });
  };

  //--------------------------------------------
  // Modify the handlePlatformSelectClick function
  const handlePlatformSelectClick = async (platformId: string) => {
    // this state is to tell us if the platform are change (diferences in betweeen platformId and currentPlatform)
    setNewClickOnPlatofrm(true);
    const isAlreadySelected = leaguePlatforms.find((p) => p.id === platformId && p.isSelected);

    // if the platform is already selected, do nothing to avoid unnecessary requests
    if (isAlreadySelected) {
      // setIsChangingPlatform(false);
      return;
    }

    platformSelectRequestIdRef.current = platformId;

    // Clear stale thoughts instantly
    cancelPendingRequests();
    if (setThoughtsCommon) {
      setThoughtsCommon("");
    }

    setIsChangingPlatform(true);
    setSelectedTeamInfo(null);
    setSelectedPartner("");
    setLeagueIdPlatform("");

    const currentPlatform = leaguePlatforms.find((p) => p.isSelected)?.id;

    // console.log("HANDLEPLATFORMSELECLICK currentPlatform", currentPlatform);

    // console.log("HANDLEPLATFORMSELECLICK currentPlatform", currentPlatform);
    // console.log("HANDLEPLATFORMSELECLICK platformId", platformId);

    // Close the accordion temporarily 
    // If the data is in cache (without await), React groups the states and opens instantly.
    // If it makes a fetch, the accordion remains closed showing only the loader.
    setExpanded("");

    // console.log(newClickOnPlatofrm && currentPlatform !== platformId);

    // Clean any existing shake effect before continuing
    if (shakingPlatform && shakingPlatform !== platformId) {
      setShakingPlatform(null);
      setDeletionMode(null);
    }

    try {
      // Update the selected platform in the leaguePlatforms
      const updatedPlatforms = leaguePlatforms.map((p) => ({
        ...p,
        isSelected: p.id === platformId,
      }));
      setLeaguePlatforms(updatedPlatforms);

      // 1. Get the platform data before updating the UI
      let platformTeamsData = teamsDataCache[platformId];
      let platformUserData = userDataCache[platformId];
      const platformObj = leaguePlatforms.find((p) => p.id === platformId);

      // Cache expiration logic: 10 minutes (10 * 60 * 1000 = 600,000 ms)
      const TEN_MINUTES_MS = 600000;
      // const TEN_MINUTES_MS = 10000; // 10 seconds for testing

      const lastFetchTime = teamsDataFetchTimestamps.current[platformId] || 0;
      const isCacheExpired = (Date.now() - lastFetchTime) > TEN_MINUTES_MS;

      // If the data expired or doesn't exist, fetch fresh leagues
      // Un-Synced: local leagues only — never call getUserLeagues
      if ((!platformTeamsData || isCacheExpired) && platformUserData && platformObj && !isUnsyncedPlatform(platformId)) {
        console.log(`Cache miss or expired for ${platformId}. Fetching fresh team list...`);
        try {
          const accessTokenFromAuth0 = await getSafeAccessAuth0Token();
          if (accessTokenFromAuth0) {
            const signal = createNewAbortController();

            // Yahoo: refresh access token via backend before get_user_leagues (same as TeamsDropdown)
            if (platformId === "Yahoo") {
              const freshYahooToken = await getValidYahooToken();
              if (platformSelectRequestIdRef.current !== platformId) {
                return;
              }
              if (!freshYahooToken) {
                setTeamsdata(null);
                setIsChangingPlatform(false);
                setNewClickOnPlatofrm(false);
                return;
              }
              platformUserData = { ...platformUserData, token: freshYahooToken };
            }

            const freshTeamsData =
              platformObj.name.toLowerCase() === "espn"
                ? await getUserLeaguesEspn(platformUserData, accessTokenFromAuth0, pocToken, signal)
                : await getUserLeagues(platformUserData, accessTokenFromAuth0, pocToken, signal);

            platformTeamsData = freshTeamsData;

            // Update global cache and register the new timestamp
            setTeamsDataCache((prev) => ({ ...prev, [platformId]: platformTeamsData }));
            teamsDataFetchTimestamps.current[platformId] = Date.now();
          }
        } catch (error) {
          console.error(`Failed to fetch fresh team list for ${platformId}`, error);
          // If the endpoint fails silently, 'platformTeamsData' keeps the old data
          // ensuring that the UI doesn't break and the user keeps seeing their teams
          if (platformSelectRequestIdRef.current !== platformId) {
            return;
          }
        }
      }

      // Drop stale result if the user switched platforms while this fetch was in flight
      if (platformSelectRequestIdRef.current !== platformId) {
        return;
      }

      // Update the UI with the final data (fresh if expired, or old if failed/not expired)
      setTeamsdata(platformTeamsData);

      const hasTeams =
        Array.isArray(platformTeamsData)
          ? platformTeamsData.length > 0
          : Boolean(platformTeamsData?.leagues?.length);

      // ========== PLATFORM SWITCH: synced = manual TeamsDropdown; Un-Synced keeps auto-select ==========
      // To RE-ENABLE synced auto-select: restore [OLD SYNCED] block below and remove [NEW SYNCED].
      // selectedTeams still persisted on manual pick (TeamsDropdown) — we only stop applying it here.

      // Un-Synced: keep previous auto-select behavior (boot effect also covers refresh).
      if (isUnsyncedPlatform(platformId)) {
        const previousTeamInfo = selectedTeams[platformId];
        const teamExistsForRestore =
          previousTeamInfo &&
          platformTeamsData?.leagues?.some(
            (team) => team.league_id === previousTeamInfo.leagueId && team.name === previousTeamInfo.teamName
          );
        // No valid saved team (e.g. right after disconnecting a synced platform): fall back to the
        // first local league — same league the boot auto-select effect uses.
        const firstLocalLeague = platformTeamsData?.leagues?.[0];
        const teamToAutoSelect = teamExistsForRestore
          ? { teamName: previousTeamInfo.teamName, leagueId: previousTeamInfo.leagueId }
          : firstLocalLeague?.league_id && firstLocalLeague?.name
            ? { teamName: firstLocalLeague.name, leagueId: firstLocalLeague.league_id }
            : null;
        // Un-Synced: single local league — never open teams accordion (auto-restore only)
        setExpanded("");
        if (teamToAutoSelect) {
          // Let React commit setLeaguePlatforms/setTeamsdata before reading the imperative handle:
          // TeamsDropdown unmounts while no platform is selected (disconnect with the grid open),
          // so teamsHomePageRef is still null at this point on that path.
          await new Promise((resolve) => setTimeout(resolve, 50));
        }
        if (teamToAutoSelect && teamsHomePageRef.current) {
          setExpanded("");
          teamsHomePageRef.current.playFunnyTeamAudio?.(teamToAutoSelect.teamName, teamToAutoSelect.leagueId, platformId);
          await teamsHomePageRef.current.handlePartnerClick(teamToAutoSelect.teamName, teamToAutoSelect.leagueId, platformId);
        } else {
          setIsChangingPlatform(false);
          setMessage("Click on the team you want to look at below");
        }
      } else {
        // [NEW SYNCED] Always open TeamsDropdown — user picks league manually.
        setExpanded(hasTeams ? "panel1" : "");
        setIsChangingPlatform(false);
        setMessage("Click on the team you want to look at below");

        // const platformUserData = userDataCache[platformId]; // Get user data as well
        // // CACHE RECOVERY LOGIC: If we are logged in but teams are not in cache, fetch them now.
        // if (!platformTeamsData && platformUserData) {
        //   console.log(`Cache miss for ${platformId}. Fetching team list...`);
        //   try {
        //     const accessTokenFromAuth0 = await getSafeAccessAuth0Token();
        //     if (!accessTokenFromAuth0) {
        //       // Logout is in progress. Stop execution and ensure loading is false.
        //       return null;
        //     }
        //     // if (!accessTokenFromAuth0) throw new Error("Could not get access token.");

        //     const signal = createNewAbortController();
        //     const freshTeamsData = await getUserLeagues(platformUserData, accessTokenFromAuth0, pocToken, signal);

        //     // Update the local variable so the rest of the function can use the fresh data
        //     platformTeamsData = freshTeamsData;

        //     // Update cache and state, just like in handlePlatformLoginClick
        //     setTeamsDataCache((prev) => ({ ...prev, [platformId]: platformTeamsData }));
        //     setTeamsdata(platformTeamsData);
        //   } catch (error) {
        //     console.error(`Failed to fetch team list for ${platformId}`, error);
        //     setTeamsdata(null); // Ensure it's null on failure
        //   }
        // } else {
        //   // If data was in cache, just set it as before.
        //   setTeamsdata(platformTeamsData);
        // }

        // [OLD SYNCED] Auto-select last league from selectedTeams — To RE-ENABLE: UNCOMMENT this block ---
        // const previousTeamInfo = selectedTeams[platformId];
        // const teamExistsForRestore =
        //   previousTeamInfo &&
        //   platformTeamsData?.leagues?.some(
        //     (team) => team.league_id === previousTeamInfo.leagueId && team.name === previousTeamInfo.teamName
        //   );
        // Kept for rollback reference (was used to skip opening accordion on auto-restore)
        // const willAutoSelectTeam = Boolean(teamExistsForRestore && teamsHomePageRef.current);
        // UI: open teams accordion only when user must pick manually.
        // Skip if auto-restore will run — avoids 1-frame flash before setExpanded("") below.
        // OLD: setExpanded(hasTeams && !willAutoSelectTeam ? "panel1" : "");
        // setExpanded(hasTeams && !teamExistsForRestore ? "panel1" : "");
        // if (previousTeamInfo && teamsHomePageRef.current) {
        //   if (teamExistsForRestore) {
        //     // Allow React to commit setTeamsdata before handlePartnerClick reads teamsData prop
        //     await new Promise((resolve) => setTimeout(resolve, 50));
        //     // Auto-selected a saved league → collapse immediately before the async restore flow finishes.
        //     setExpanded("");
        //     teamsHomePageRef.current.playFunnyTeamAudio?.(previousTeamInfo.teamName, previousTeamInfo.leagueId, platformId); // play funny team name audio in auto-select team (without clicking on the team)
        //     await teamsHomePageRef.current.handlePartnerClick(previousTeamInfo.teamName, previousTeamInfo.leagueId, platformId);
        //   } else {
        //     setIsChangingPlatform(false);
        //     setMessage("Click on the team you want to look at below");
        //   }
        // } else {
        //   setIsChangingPlatform(false);
        //   setMessage("Click on the team you want to look at below");
        // }
      }
    } catch (error) {
      console.error("Error in handlePlatformSelectClick:", error);
      throw error; // Re-throw para que lockPlatformTransition lo maneje
    } finally {
    }
    setIsChangingPlatform(false);
    setNewClickOnPlatofrm(false);
  };

  //--------------------------------------------

  const loginAbortController = useRef<AbortController | null>(null);

  //function to handle platform login click
  const handlePlatformLoginClick = async (platformLeagueId, userName, password) => {
    // Cancel all pending requests before changing platform
    cancelPendingRequests();
    setSelectedPartner("");
    setSelectedTeamInfo(null);

    // setTeamsdata(null); // Clear the teams data to avoid stale data
    const currentPlatform = leaguePlatforms.find((p) => p.isSelected)?.id;

    // console.log("HANDLEPLATFORMLOGINSELECT currentPlatform", currentPlatform);
    // console.log("HANDLEPLATFORMLOGINSELECT platformLeagueId", platformLeagueId);
    setNewClickOnPlatofrm(true);
    setIsChangingPlatform(true);

    // Cancel any existing login requests
    if (loginAbortController.current) {
      loginAbortController.current.abort();
    }
    loginAbortController.current = new AbortController();
    const signal = loginAbortController.current.signal;

    let selectedPlatform = leaguePlatforms.find((platform) => platform.id === platformLeagueId);

    try {
      setLeagueIdPlatform(null);
      // let selectedPlatform = leaguePlatforms.find((platform) => platform.id === platformLeagueId);
      let userDataPlatform;

      const accessAuthToken = await getSafeAccessAuth0Token();
      if (!accessAuthToken) {
        setLoggingInTo(null); // Clean up UI state
        return; // Stop execution
      }

      if (selectedPlatform.name.toLowerCase() === "fleaflicker") {
        userDataPlatform = {
          integration_name: "fleaflicker",
          user_id: userName,
          token: pocToken,
        };
      } else if (selectedPlatform.name.toLowerCase() === "fantrax") {
        userDataPlatform = {
          integration_name: "fantrax",
          user_id: userName,
          sport: "nfl",
          // year: "2025",
        };
      } else if (selectedPlatform.id === "FFPC") {
        // FFPC has no password; skip login_fantasy_platform and go straight to getUserLeagues
        userDataPlatform = {
          integration_name: "ffpc",
          user_id: userName,
          sport: "nfl",
        };
      } else if (selectedPlatform.name.toLowerCase() === "espn") {
        const espnData = password; // password contains { sessionId, passcode }
        userDataPlatform = await loginEspnPlatform(
          userName, // This is the email
          espnData.sessionId,
          espnData.passcode,
          accessAuthToken,
          pocToken,
          signal
        );

        console.log("userDataPlatformESPN", userDataPlatform);

        userDataPlatform.user_email = userName;

        if (userDataPlatform.error) {
          console.log("userDataPlatformESPN.error", userDataPlatform.error);
          // throw new Error(userDataPlatform.error);
        }
      } else {
        userDataPlatform = await loginFantasyPlatform(userName, selectedPlatform.name.toLowerCase(), password, accessAuthToken, pocToken, signal);
      }

      const teamsDataForPlatform =
        selectedPlatform.name.toLowerCase() === "espn"
          ? await getUserLeaguesEspn(userDataPlatform, accessAuthToken, pocToken, signal)
          : await getUserLeagues(userDataPlatform, accessAuthToken, pocToken, signal);

      // const teamsDataForPlatform = await getUserLeagues(userDataPlatform, accessAuthToken, pocToken, signal);

      if (selectedPlatform.id === "FFPC") {
        const hasFfpcTeams = Array.isArray(teamsDataForPlatform)
          ? teamsDataForPlatform.length > 0
          : Boolean(teamsDataForPlatform?.leagues?.length);
        if (!hasFfpcTeams) {
          throw new Error("Account not found. Please try again.");
        }
      }

      // Update the cache with the data for the selected platform
      setTeamsDataCache((prev) => ({
        ...prev,
        [platformLeagueId]: teamsDataForPlatform,
      }));

      // Register the exact moment in which the leagues were fetched when logging in
      teamsDataFetchTimestamps.current[platformLeagueId] = Date.now();

      // Store the userDataPlatform in the cache
      setUserDataCache((prev) => ({
        ...prev,
        [platformLeagueId]: userDataPlatform,
      }));

      // Persist platform permission for this platform/account
      try {
        const platformKey = selectedPlatform.name.toLowerCase();
        const rawAccountKey = typeof userName === "string" ? userName : "";

        let accountKey = rawAccountKey ? rawAccountKey.trim() : "";

        // For Yahoo, prefer the platform user_id if available
        if (platformKey === "yahoo" && userDataPlatform && typeof userDataPlatform.user_id === "string" && userDataPlatform.user_id.trim()) {
          accountKey = userDataPlatform.user_id.trim();
        }

        // const platformUserId = userDataPlatform && typeof userDataPlatform.user_id === "string" ? userDataPlatform.user_id : "";

        // MFL and ESPN don't provide platform user_id; use accountKey (username/email) for platformUserId
        let platformUserId: string;
        if (platformKey === "mfl" || platformKey === "espn") {
          platformUserId = accountKey;
        } else {
          platformUserId = userDataPlatform && typeof userDataPlatform.user_id === "string" ? userDataPlatform.user_id : "";
        }

        if (accountKey) {
          await savePlatformPermission(accessAuthToken, {
            platform: platformKey,
            accountKey,
            platformUserId,
          });
        }
      } catch (permissionError) {
        console.error("Error saving platform permission:", permissionError);
      }

      // Update platforms
      const newPlatforms = leaguePlatforms.map((platform) => ({
        ...platform,
        isLoggedIn: platform.id === platformLeagueId ? true : platform.isLoggedIn,
        isSelected: platform.id === platformLeagueId ? true : false,
      }));

      setLeaguePlatforms(newPlatforms);

      const hasTeams =
        Array.isArray(teamsDataForPlatform)
          ? teamsDataForPlatform.length > 0
          : Boolean(teamsDataForPlatform?.leagues?.length);
      setExpanded(hasTeams && !isUnsyncedPlatform(platformLeagueId) ? "panel1" : "");
      // setExpanded("");

      setLoggingInTo(null);
      setIsAddIcon(true);
      setIsSpeedDialOpen(false);

      // Track successful login
      await trackPlatformLogin(authId, selectedPlatform.name, true);
    } catch (error) {
      console.error("Error:", error);
      setLoginError(error.message || "An error occurred during login");
      setIsChangingPlatform(false);
      // Track failed login
      await trackPlatformLogin(authId, selectedPlatform.name, false);
      throw error; // Important: propagate the error so LoginForm can handle it for the loader
      setNewClickOnPlatofrm(false);
    } finally {
      setIsChangingPlatform(false);
      // Clean up abort controller
      if (loginAbortController.current) {
        loginAbortController.current = null;
      }
      setNewClickOnPlatofrm(false);
    }
  };

  //--------------------------------------------

  //Function to handle platform delete click
  const handlePlatformDeleteClick = async (platformId) => {
    // Un-Synced cannot be disconnected (virtual platform)
    if (isUnsyncedPlatform(platformId)) {
      return;
    }
    const keepPlatformPickerOpen = expanded === "panel0";
    try {
      const accessAuthToken = await getSafeAccessAuth0Token();
      if (!accessAuthToken) {
        return; // Stop execution
      }
      const signal = createNewAbortController();
      // Find the next logged-in platform available (skip auto-select when platform grid is open)
      const nextLoggedPlatform = keepPlatformPickerOpen
        ? undefined
        : leaguePlatforms.find((platform) => platform.id !== platformId && platform.isLoggedIn);

      // Update the platforms
      const newPlatforms = leaguePlatforms.map((platform) => ({
        ...platform,
        isLoggedIn: platform.id === platformId ? false : platform.isLoggedIn,
        // If there is another logged-in platform available, select it (unless user is picking from grid)
        isSelected: keepPlatformPickerOpen
          ? false
          : nextLoggedPlatform
            ? platform.id === nextLoggedPlatform.id
            : false,
      }));

      // clean the cache
      const newTeamsCache = { ...teamsDataCache };
      const newUserCache = { ...userDataCache };
      delete newTeamsCache[platformId];
      delete newUserCache[platformId];

      // clean the selectedTeams
      const newSelectedTeams = { ...selectedTeams };
      delete newSelectedTeams[platformId];

      // update the state of the platform
      setLeaguePlatforms(newPlatforms);
      setTeamsDataCache(newTeamsCache);
      setUserDataCache(newUserCache);
      setSelectedTeams(newSelectedTeams); // Update selected teams in context

      // guard clause to avoid updating the teamsdata if the platform is not logged in
      if (nextLoggedPlatform) {
        setTeamsdata(newTeamsCache[nextLoggedPlatform.id] || null);
      } else {
        setTeamsdata(null);
      }

      // console.log(`Platform ${platformId} deleted. Clearing current UI states.`);

      setSelectedTeamInfo(null);
      setSelectedPartner("");
      setLeagueIdPlatform(null);
      // setTeamsdata(null);

      //clean the section data
      setSectionData({
        commonLeagueData: null,
        news: null,
        rosters: null,
        rankings: null,
        allRankings: null,
        waiver: null,
        rundown: null,
        DraftAdvice: null,
        start: null,
        superFunction: null,
      });

      //clean the section data
      if (setWaiverData) setWaiverData({ waiver_analysis: "", chart_data: [], request_id: null });
      if (setNewsData) setNewsData(null);
      if (setStartData) setStartData({ start_analysis: "", chart_data: [], request_id: null });
      if (setRostersData) setRostersData(null);
      if (setRankingsData) setRankingsData(null);
      if (setAllRankingsData) setAllRankingsData(null);
      if (setRundownData) setRundownData({ rundown_analysis: "", chart_data: [], request_id: null });
      if (setDraftAdviceData) setDraftAdviceData({ rundown_analysis: "", chart_data: [], request_id: null });

      // update the state of the platform in the backend
      await postUserPreferences(
        accessAuthToken,
        {
          loggedPlatforms: newPlatforms,
          teamsData: newTeamsCache,
          userDataPlatform: newUserCache,
          selectedTeams: newSelectedTeams,
        },
        signal
      );

      setLoggingInTo(null);
      // setExpanded("");
      setIsAddIcon(true);
      setIsSpeedDialOpen(false);

      // Update message according to the result
      if (nextLoggedPlatform) {
        setMessage(`Platform disconnected. ${nextLoggedPlatform.name} is now selected.`);
      } else {
        setMessage("Platform disconnected successfully");
        // setIsChangingPlatform(false);
      }
    } catch (error) {
      console.error("Error removing platform:", error);
      setMessage("Error disconnecting platform. Please try again.");
      // setIsChangingPlatform(false);
    }
  };

  //--------------------------------------------
  //function to handle login close when its yahoo and there is an error
  const handleLoginCloseYahoo = () => {
    const closedPlatformId = loggingInTo;
    // This cleanup is for when re-authentication fails and the user closes the form.
    if ((loggingInTo === "Yahoo" || loggingInTo === "ESPN") && loginError === "Please connect again") {
      // Reset loading states to stop spinners
      setLoadingNews(false);
      setLoadingWaiver(false);
      setLoadingStart(false);
      setLoadingRoster(false);
      setLoadingRankings(false);
      setLoadingAllRankings(false);
      setLoadingRundown(false);
      setLoadingDraftAdvice(false);
      setHasLoadingStarted(false);

      // Revert team selection to clean up UI
      setSelectedTeamInfo(null);
      setSelectedPartner("");
      setLeagueIdPlatform(null);
      setTeamsdata(null);
    }
    setLoggingInTo(null);
    setLoginError(null);
    // Opening Yahoo turns this on and never clears it if the form is dismissed.
    // Home hides the whole page while Yahoo is selected and this flag is still true.
    if (closedPlatformId === "Yahoo") setIsYahooLoading(false);

    // X on the login form uses this handler, not onClose.
    // Dismissed without connecting: leave THAT platform selected, with no team, so the header says "Click to connect again".
    const platform = leaguePlatforms.find((p) => p.id === closedPlatformId);
    if (!platform || platform.isLoggedIn || isUnsyncedPlatform(platform.id)) return;
    setLeaguePlatforms(leaguePlatforms.map((p) => ({ ...p, isSelected: p.id === platform.id })));
    setTeamsdata(null);
    setSelectedTeamInfo(null);
    setSelectedPartner("");
    setLeagueIdPlatform("");
    setExpanded("");
  };

  // Function to handle select team button click when there is no teams data
  const handleSelectTeamButtonClick = () => {
    const selectedPlatform = leaguePlatforms.find((p) => p.isSelected);
    if (teamsData === null && selectedPlatform) {
      setLoggingInTo(selectedPlatform.id);
      return;
    }
    // Synced: teams accordion stays open — header click no longer toggles panel1.
    // else if (!isChangingPlatform && hasTeams && !isUnsyncedPlatformSelected) {
    //   setExpanded(expanded === "panel1" ? "" : "panel1");
    // }
    // No team yet, or Un-Synced: do not toggle. "Select Team" stays expanded.
    if (isUnsyncedPlatformSelected || isChangingPlatform || !partnerMatchesSelectedPlatform) return;
    setExpanded(expanded === "panel1" ? "" : "panel1");
  };
  //--------------------------------------------

  // Function to handle saving league settings and triggering refresh
  // Un-Synced only: rename local league display name (league_id unchanged). Persists via user preferences.
  const handleRenameUnsyncedLeague = async (newName: string) => {
    if (!selectedTeamInfo || !isUnsyncedPlatform(selectedTeamInfo.platformId)) return;

    const trimmed = newName.trim();
    if (!trimmed) return;

    const leagueId = selectedTeamInfo.leagueId;
    const prevUnsynced = teamsDataCache[UNSYNCED_PLATFORM_ID];
    const nextUnsyncedTeams = {
      ...prevUnsynced,
      leagues: (prevUnsynced?.leagues || []).map((league) =>
        league.league_id === leagueId ? { ...league, name: trimmed } : league,
      ),
    };
    const nextTeamsDataCache = {
      ...teamsDataCache,
      [UNSYNCED_PLATFORM_ID]: nextUnsyncedTeams,
    };
    const nextSelectedTeams = {
      ...selectedTeams,
      [UNSYNCED_PLATFORM_ID]: {
        platformId: UNSYNCED_PLATFORM_ID,
        leagueId,
        teamName: trimmed,
      },
    };
    const nextTeamInfo = {
      ...selectedTeamInfo,
      teamName: trimmed,
    };

    setTeamsDataCache(nextTeamsDataCache);
    setSelectedTeams(nextSelectedTeams);
    setSelectedTeamInfo(nextTeamInfo);
    setSelectedPartner(trimmed);
    setTeamsdata(nextUnsyncedTeams);

    const accessAuthToken = await getSafeAccessAuth0Token();
    if (!accessAuthToken) return;

    await postUserPreferences(accessAuthToken, {
      loggedPlatforms: leaguePlatforms,
      teamsData: nextTeamsDataCache,
      userDataPlatform: userDataCache,
      selectedTeams: nextSelectedTeams,
    });
  };

  const handleSaveLeagueSettings = (newCalculatorSettings: any) => {
    // Save the calculator_settings payload to state
    setCalculatorSettings(newCalculatorSettings);
    // Set flag to indicate settings changed (will be used by endpoints)
    setLeagueSettingsChanged(true);
    // Trigger refresh to re-execute endpoints with new settings
    // Pass calculatorSettings directly to avoid async state update issue
    handleRefreshEndpoints(newCalculatorSettings);
  };

  // Function to handle resetting league settings and triggering refresh WITHOUT calculator_settings
  const handleResetLeagueSettings = async () => {
    // Clear calculator_settings to null so endpoints won't send the key
    // This removes the entry for the current team from calculatorSettingsMap
    setCalculatorSettings(null);
    // Reset flag to indicate no settings changes
    setLeagueSettingsChanged(false);

    // CRITICAL: Force immediate save to MongoDB to persist the deletion
    // Wait for React state update to complete before saving
    // This ensures the calculatorSettingsMap (without the current team's entry) is saved to MongoDB
    setTimeout(async () => {
      try {
        await forceSavePreferences();
        console.log("✅ RESET: calculatorSettingsMap saved to MongoDB (team entry removed)");
      } catch (error) {
        console.error("❌ RESET: Error saving to MongoDB:", error);
      }
    }, 0);

    // Trigger refresh WITHOUT calculator_settings (pass null/undefined)
    // This will make endpoints NOT include the calculator_settings key in the payload
    handleRefreshEndpoints(null);
  };

  // Function to handle save success callback from LeagueSettings
  // Marks save as pending - useEffect will show CheckCircleIcon when BOTH flows complete
  const handleSaveSuccess = () => {
    // Always mark as pending - useEffect will handle showing CheckCircleIcon
    // when BOTH common_league_data AND super_analysis complete
    pendingSaveSuccessRef.current = true;
  };

  const handleRefreshEndpoints = async (calculatorSettingsOverride?: any) => {
    console.log("🔄 Refreshing endpoints");
    // Check if there is a team selected
    if (!selectedTeamInfo || !teamsHomePageRef.current) {
      console.warn("No team selected or teamsHomePageRef not available");
      return;
    }

    try {
      // 1. Clean the sectionData for the current team to force a new execution
      const currentPlatform = leaguePlatforms.find((p) => p.isSelected)?.id;
      const { platformId, leagueId, teamName } = selectedTeamInfo;

      console.log("handleRefreshEndpoints: platformId", platformId);
      console.log("handleRefreshEndpoints: currentPlatform", currentPlatform);
      // Check if the current team matches the selected team
      if (platformId !== currentPlatform) {
        console.warn("Platform mismatch, cannot refresh");
        return;
      }

      // 2. Clean the sectionData specific for this team
      // This will make isCacheValid return false and force a new execution
      const shouldClearCache =
        sectionData.commonLeagueData?.platform === platformId && sectionData.commonLeagueData?.leagueId === leagueId && sectionData.commonLeagueData?.teamName === teamName;

      setForceRefresh(true); // set the force refresh flag to true
      setIsSuperAnalysisComplete(false); // set the super analysis complete flag to false to avoid showing the loader icon
      setRefreshingLeagueData(true); // set the refreshing league data flag to true for loader icon

      // CRITICAL: Reset ALL button progress BEFORE activating loadings
      // This ensures buttons start from 0% when refresh is triggered
      // Keys must match AnimatedButton: `${authId}-${platformId}-${leagueId}-${label.toLowerCase()}`
      const progressPrefix = `${authId}-${platformId}-${leagueId}-`;
      ["waivers", "start/sit", "team analysis", "draft advice"].forEach((label) => {
        updateButtonProgress(`${progressPrefix}${label}`, 0);
      });
      // Automatic buttons (News, Rankings, all Rankings, Rosters)
      ["news", "rankings", "all rankings", "rosters"].forEach((label) => {
        updateButtonProgress(`${progressPrefix}${label}`, 0);
      });

      if (shouldClearCache) {
        setSectionData({
          ...sectionData,
          commonLeagueData: null,
          waiver: null,
          start: null,
          rundown: null,
          DraftAdvice: null,
          news: null,
          rosters: null,
          rankings: null,
          allRankings: null,
          superFunction: null,
        });
      }

      setLoadingNews(true);
      setLoadingWaiver(false);
      setLoadingStart(false);
      setLoadingRoster(true);
      setLoadingRankings(true);
      setLoadingAllRankings(true);
      setLoadingRundown(false);
      setLoadingDraftAdvice(false);
      setHasLoadingStarted(true);

      // 3. Clean the local data states to avoid showing old data
      setWaiverData({ waiver_analysis: "", chart_data: [], request_id: null });
      setStartData({ start_analysis: "", chart_data: [], request_id: null });
      setRundownData({ rundown_analysis: "", chart_data: [], request_id: null });
      setDraftAdviceData({ rundown_analysis: "", chart_data: [], request_id: null });
      setNewsData(null);
      setRostersData(null);
      setRankingsData(null);
      setAllRankingsData(null);

      // 4. Clean the stream states to avoid showing old data
      setWaiverStreamState({
        status: "",
        thought: "",
        isGeneratingResult: false,
        isStreamActive: false,
        isWaitingForChart: false,
        isGeneratingAudio: false,
        teamKey: null,
      });
      setStartStreamState({
        status: "",
        thought: "",
        isGeneratingResult: false,
        isStreamActive: false,
        isWaitingForChart: false,
        isGeneratingAudio: false,
        teamKey: null,
      });
      setRundownStreamState({
        status: "",
        thought: "",
        isGeneratingResult: false,
        isStreamActive: false,
        isWaitingForChart: false,
        isGeneratingAudio: false,
        teamKey: null,
      });
      setDraftAdviceStreamState({
        status: "",
        thought: "",
        isGeneratingResult: false,
        isStreamActive: false,
        isWaitingForChart: false,
        isGeneratingAudio: false,
        teamKey: null,
      });

      // 5. Clean the audios to avoid showing old data
      setSummaryAudios({
        rundown: null,
        DraftAdvice: null,
        waiver: null,
        start: null,
      });
      hasAudioBeenPlayed.current = {
        rundown: false,
        DraftAdvice: false,
        waiver: false,
        start: false,
      };

      // 6. Clean the previous errors to avoid showing old errors
      setEndpointErrors({});
      setErrorMessages({
        "League Data": "",
        Trades: "",
        "Analyze Trade": "",
        Rundown: "",
        DraftAdvice: "",
        Start: "",
        News: "",
        Rankings: "",
        AllRankings: "",
        Waiver: "",
      });
      setErrorMessageNoDraft({
        waiver: false,
        news: false,
        start: false,
        rankings: false,
        allRankings: false,
        rosters: false,
        rundown: false,
        DraftAdvice: false,
      });

      // 7. CRITICAL: Remove polling keys from activeStreamRequests BEFORE canceling
      // This prevents old polling from reactivating after refresh
      const waiverKey = `${authId}-waiver-${platformId}-${leagueId}`;
      const startKey = `${authId}-start-${platformId}-${leagueId}`;
      const rundownKey = `${authId}-rundown-${platformId}-${leagueId}`;
      const DraftAdviceKey = `${authId}-DraftAdvice-${platformId}-${leagueId}`;

      activeStreamRequests.current.delete(waiverKey);
      activeStreamRequests.current.delete(startKey);
      activeStreamRequests.current.delete(rundownKey);
      activeStreamRequests.current.delete(DraftAdviceKey);

      console.log(`🔄 Removed polling keys on refresh: ${waiverKey}, ${startKey}, ${rundownKey}, ${DraftAdviceKey}`);

      // 8. Cancel any pending requests
      cancelPendingRequests();

      // 9. Create a new AbortController for the refresh
      const controller = new AbortController();
      setCurrentAbortController(controller);

      // 10. Re-execute handlePartnerClick with the current team
      // This will force a new execution because the sectionData is clean
      // Pass calculatorSettingsOverride if provided (from handleSaveLeagueSettings)
      console.log("forceRefresh before handlePartnerClick", forceRefresh);
      await teamsHomePageRef.current.handlePartnerClick(teamName, leagueId, platformId, controller.signal, true, calculatorSettingsOverride);
      // setForceRefresh(false); // reset the force refresh flag
      // Check if the team changed during the refresh
      // If the team is different now, reset forceRefresh
      // if (selectedTeamInfo?.platformId === platformId && selectedTeamInfo?.leagueId === leagueId && selectedTeamInfo?.teamName === teamName) {
      //   setForceRefresh(false);
      // }

      console.log("selectedTeamInfo handleRefreshEndpoints ", selectedTeamInfo);
      console.log("platformId handleRefreshEndpoints ", platformId);
      console.log("leagueId  handleRefreshEndpoints", leagueId);
      console.log("teamName handleRefreshEndpoints", teamName);

      // console.log("forceRefresh after handlePartnerClick", forceRefresh);
      // setRefreshingLeagueData(false); // set the refreshing league data flag to false for show refresh icon again
      setIsSuperAnalysisComplete(true); // set the super analysis complete flag to true to show the loader icon again
      console.log("✅ Refresh completed");
      // --- NEW TIMESTAMP LOGIC ---
      const now = new Date();
      const date = `${(now.getMonth() + 1).toString().padStart(2, "0")}-${now.getDate().toString().padStart(2, "0")}-${now.getFullYear().toString().slice(-2)}`;
      const time = `${now.getHours().toString().padStart(2, "0")}:${now.getMinutes().toString().padStart(2, "0")}:${now.getSeconds().toString().padStart(2, "0")}`;
      const newTimestamp = `${date} ${time}`;

      const teamKey = `${platformId}-${leagueId}`;
      setLastUpdatedTimestamps((prev) => ({
        ...prev,
        [teamKey]: newTimestamp,
      }));

      setRefreshingLeagueData(false); // set the refreshing league data flag to false for show refresh icon again

      // Reset loaders of manual buttons to 0% for the current team
      // Keys like in AnimatedButton: `${authId}-${platformId}-${leagueId}-${label.toLowerCase()}`
      // const progressPrefix = `${authId}-${platformId}-${leagueId}-`;
      // ["waivers", "start/sit", "analysis"].forEach((label) => {
      //   updateButtonProgress(`${progressPrefix}${label}`, 0);
      // });
    } catch (error) {
      console.error("❌ Error refreshing endpoints:", error);
      if (error.name !== "AbortError") {
        setMessage("Error refreshing data. Please try again.");
      }
    }
  };

  const previousTeamKeyRef = useRef<string | null>(null);
  const previousSelectionToggleRef = useRef<boolean>(false); // track newClickOnPlatofrm edges

  useEffect(() => {
    // Unique key for the current team
    const currentTeamKey = selectedTeamInfo ? `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}-${selectedTeamInfo.teamName}` : null;

    // 1) Si el team realmente cambió → reset forceRefresh
    if (previousTeamKeyRef.current !== null && currentTeamKey !== previousTeamKeyRef.current) {
      setForceRefresh(false);
      console.log("🔄 forceRefresh reset to false because the team changed.");
    }

    // 2) Si se seleccionó el MISMO team desde el dropdown:
    // detectamos flanco de bajada (true -> false) de newClickOnPlatofrm,
    // y si la key es la misma, reseteamos forceRefresh.
    const selectionFinished = previousSelectionToggleRef.current && !newClickOnPlatofrm;
    if (selectionFinished && currentTeamKey === previousTeamKeyRef.current && forceRefresh) {
      setForceRefresh(false);
      console.log("🔄 forceRefresh reset to false after re-selecting the SAME team from dropdown.");
    }

    // Actualizar refs para próximo ciclo
    previousTeamKeyRef.current = currentTeamKey;
    previousSelectionToggleRef.current = newClickOnPlatofrm;
  }, [
    selectedTeamInfo?.platformId,
    selectedTeamInfo?.leagueId,
    selectedTeamInfo?.teamName,
    newClickOnPlatofrm, // <- clave para detectar selección del mismo team
    forceRefresh,
    setForceRefresh,
  ]);

  // useEffect(() => {
  //   // When the selected team changes, the "refresh session" is over.
  //   // Reset the forceRefresh flag back to false.
  //   setForceRefresh(false);
  //   console.log("forceRefresh reset to false:", forceRefresh);
  // }, [selectedTeamInfo]);

  // Helper function to truncate platform name if longer than 25 characters on mobile (remove the last 3 characters and add ...)
  const truncatePlatformName = (name: string): string => {
    return name.length > 25 ? `${name.substring(0, 25)}...` : name;
  };

  //function for timestamp but here, outside the jsx
  const getTimestamp = () => {
    const teamKey = selectedTeamInfo ? `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : null;
    const timestamp = teamKey ? lastUpdatedTimestamps[teamKey] : null;

    if (!timestamp) {
      // if the timestamp is not set, show "Not updated yet"
      return (
        <Typography variant="h3" sx={{ color: "#bbbbbb", fontSize: "10px" }}>
          Not updated yet
        </Typography>
      );
    } else if (refreshingLeagueData) {
      // if the refreshing league data flag is true, show "Updating"
      return (
        <Typography variant="h3" sx={{ color: "#bbbbbb", fontSize: "10px" }}>
          Updating
        </Typography>
      );
    } else {
      const [datePart, timePart] = timestamp?.split(" ");
      // if the timestamp is set, show the date and time
      return (
        <>
          {/* <Box sx={{ display: "flex", flexDirection: isMobile ? "row" : "row", justifyContent: isMobile ? "flex-start" : "space-between", alignItems: isMobile ? "flex-start" : "center", gap: 1 }}> */}
          <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
            <Typography variant="h3" sx={{ color: "#bbbbbb", fontSize: "10px" }}>
              {datePart}
            </Typography>
            <Typography variant="h3" sx={{ color: "#bbbbbb", fontSize: "10px" }}>
              {timePart}
            </Typography>
          </Box>
        </>
      );
    }
  };

  // this is for iphone se
  const isSmallScreen = useMediaQuery('(max-height: 667px)');
  const stableSpinnerSx = {
    // margin: "0 auto",
    color: "#FF672D",
    transform: "translateZ(0)",
    WebkitTransform: "translateZ(0)",
    "& .MuiCircularProgress-svg": {
      display: "block",
    },
  };

  // Fetch user_request_history for the selected league (drawer opens separately via HistoryIcon click)
  // Un-Synced: skip — history is not used for that platform
  const handleFetchUserRequestHistory = async () => {
    if (!selectedTeamInfo || isFetchingHistory) return;
    if (isUnsyncedPlatform(selectedTeamInfo.platformId)) return;

    setIsFetchingHistory(true);
    try {
      const accessAuthToken = await getSafeAccessAuth0Token();
      if (!accessAuthToken) return;

      const platformUserData = userDataCache[selectedTeamInfo.platformId];
      const history = await fetchUserRequestHistory(accessAuthToken, {
        offset: 0,
        order: "desc",
        league_id: selectedTeamInfo.leagueId,
        integration_name: platformUserData?.integration_name ?? null,
        user_id: platformUserData?.user_id ?? null,
      });
      // console.log("[user_request_history]", history);
      setHistoryItems(history.items ?? []);
    } catch (error) {
      console.error("[user_request_history] error:", error);
    } finally {
      setIsFetchingHistory(false);
    }
  };

  // Prefetch history when the user selects / switches team (synced platforms only)
  useEffect(() => {
    if (selectedTeamInfo && !isUnsyncedPlatform(selectedTeamInfo.platformId)) {
      handleFetchUserRequestHistory();
    }

  }, [selectedTeamInfo?.platformId, selectedTeamInfo?.leagueId, selectedTeamInfo?.teamName]);

  // console.log("selectpartner", selectedPartner);

  // Mark keeper drawer as seen in the user preferences
  const markKeeperDrawerSeen = useCallback(async () => {
    if (!selectedTeamInfo) return;
    const teamKey = `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
    // console.log("[keeperDrawerSeenMap] teamKey", teamKey);
    if (keeperDrawerSeenMap[teamKey]) return; // guard clause to avoid saving the same team key twice

    // update the keeperDrawerSeenMap with the new team key
    const nextMap = { ...keeperDrawerSeenMap, [teamKey]: true };
    setKeeperDrawerSeenMap(nextMap);
    try {
      // save the keeperDrawerSeenMap to the user preferences
      await forceSavePreferences({ keeperDrawerSeenMap: nextMap });
      // console.log("[keeperDrawerSeenMap] saved", nextMap);
    } catch (error) {
      console.error("[LeagueSelector] Error saving keeperDrawerSeenMap:", error);
    }
  }, [selectedTeamInfo, keeperDrawerSeenMap, setKeeperDrawerSeenMap, forceSavePreferences]);

  // Handle the close of the keeper drawer
  const handleKeeperDrawerClose = useCallback(async () => {
    setIsKeeperDrawerOpen(false);
    await markKeeperDrawerSeen();
  }, [markKeeperDrawerSeen]);

  // Handle the submit of the keeper drawer
  const handleKeeperSubmit = useCallback(
    async (keeperData: KeeperFormData) => {
      const leagueInfo = sectionData?.commonLeagueData?.league_info;
      if (!leagueInfo) return;

      const rawNotes = calculatorSettings?.notes ?? leagueInfo.notes ?? "";
      const { cleanNotes } = extractKeeperData(rawNotes);
      const notesToSave = injectKeeperData(cleanNotes, keeperData);

      setIsKeeperSubmitting(true);
      try {
        const accessToken = await getSafeAccessAuth0Token();
        if (!accessToken) return;

        if (notesToSave.trim()) {
          const validationResponse = await checkMaliciousNotes(accessToken, notesToSave);
          if (validationResponse.isMalicious === 1) {
            console.warn("⚠️ [KeeperDrawer] Malicious notes detected, NOT saving");
            return;
          }
        }

        // Same path as League Settings: Unlimited (Dynasty) checkbox → league_type dynasty
        const baseCalculatorSettings = calculatorSettings
          ? { ...calculatorSettings, notes: notesToSave }
          : mapLeagueInfoToCalculatorSettings(leagueInfo, notesToSave);
        const newCalculatorSettings = keeperData.isUnlimited
          ? { ...baseCalculatorSettings, league_type: "dynasty" }
          : baseCalculatorSettings;

        handleSaveLeagueSettings(newCalculatorSettings);
        handleSaveSuccess();
        setIsKeeperDrawerOpen(false);

        await markKeeperDrawerSeen();
      } catch (error) {
        console.error("[KeeperDrawer] Error saving keeper settings:", error);
      } finally {
        setIsKeeperSubmitting(false);
      }
    },
    [
      sectionData?.commonLeagueData?.league_info,
      calculatorSettings,
      getSafeAccessAuth0Token,
      markKeeperDrawerSeen,
    ]
  );

  // Auto-open keeper drawer once per keeper league (first time only)
  useEffect(() => {
    if (isLoadingPreferences || !selectedTeamInfo) return;

    const commonData = sectionData?.commonLeagueData;
    if (!commonData?.league_info) return;

    const { platformId, leagueId, teamName } = selectedTeamInfo;
    if (commonData.platform !== platformId || commonData.leagueId !== leagueId || commonData.teamName !== teamName) {
      return;
    }

    const leagueType = commonData.league_info.league_type;
    if (typeof leagueType !== "string" || leagueType.trim().toLowerCase() !== "keeper") {
      return;
    }

    const teamKey = `${platformId}-${leagueId}`;
    if (keeperDrawerSeenMap[teamKey]) return;
    if (keeperAutoOpenTriggeredRef.current === teamKey) return;

    keeperAutoOpenTriggeredRef.current = teamKey;
    setIsKeeperDrawerOpen(true);
  }, [isLoadingPreferences, selectedTeamInfo, sectionData?.commonLeagueData, keeperDrawerSeenMap]);

  useEffect(() => {
    if (isUnsyncedPlatformSelected && expanded === "panel1") {
      setExpanded("");
    }
  }, [isUnsyncedPlatformSelected, expanded, setExpanded]);

  // Un-Synced only (for rename league name, not for anohter league in another platform): rename props (avoid inline ternaries in JSX)
  const isUnsyncedSelected =
    Boolean(selectedTeamInfo) && isUnsyncedPlatform(selectedTeamInfo?.platformId);
  const unsyncedLeagueNameProp = isUnsyncedSelected ? selectedTeamInfo!.teamName : null;
  const onRenameUnsyncedLeagueProp = isUnsyncedSelected ? handleRenameUnsyncedLeague : undefined;

  return (
    <>
      <Accordion expanded={expanded === "panel0"} onChange={() => handleChange("panel0")}>
        <PlatformSelector
          leaguePlatforms={leaguePlatforms}
          expanded={expanded}
          handlePlatformSelectClick={handlePlatformSelectClick}
          handleIconClick={handleIconClick}
          handlePlatformDeleteClick={handlePlatformDeleteClick}
          handlePlatformLongPress={handlePlatformLongPress}
          setDeletionMode={setDeletionMode}
          setShakingPlatform={setShakingPlatform}
          deletionMode={deletionMode}
          shakingPlatform={shakingPlatform}
          isChangingPlatform={isChangingPlatform}
          setIsChangingPlatform={setIsChangingPlatform}
        />
        {/* Platform Dialog component in add new platform accordion */}
        <AccordionDetails
          ref={platformAccordionDetailsRef}
          sx={{
            padding: 0,
            maxHeight: expanded === "panel0" ? platformMaxHeight : "0px",
            overflow: expanded === "panel0" ? "auto" : "hidden",
          }}
          className={styles.accordionDetails}
        >
          <PlatformDropdown
            setLoggingInTo={setLoggingInTo}
            expanded={expanded}
            setExpanded={setExpanded}
            setIsAddIcon={setIsAddIcon}
            setIsSpeedDialOpen={setIsSpeedDialOpen}
            setLoginError={setLoginError}
            handlePlatformDeleteClick={handlePlatformDeleteClick}
            handlePlatformSelectClick={handlePlatformSelectClick}
            onClosePlatformPicker={() => {
              if (expanded !== "panel0") return;
              handleIconClick();
            }}
          />
        </AccordionDetails>
      </Accordion>

      {/* Login form swipeable */}
      {loggingInTo && (
        <LoginForm
          platformSelected={leaguePlatforms.find((p) => p.id === loggingInTo)}
          handlePlatformLoginClick={handlePlatformLoginClick}
          onClose={handleLoginCloseYahoo}
          loginError={loginError}
          setLoginError={setLoginError}
          setTeamsdata={setTeamsdata}
          isChangingPlatform={isChangingPlatform}
          setIsChangingPlatform={setIsChangingPlatform}
          setLoggingInTo={setLoggingInTo}
          setSelectedTeamInfo={setSelectedTeamInfo}
          setSelectedPartner={setSelectedPartner}
          setLeagueIdPlatform={setLeagueIdPlatform}
          handleLoginCloseYahoo={handleLoginCloseYahoo}
        />
      )}

      {/* Select team accordion */}
      {leaguePlatforms.filter((p) => p.isSelected).length !== 0 && (
        <Accordion
          expanded={!isUnsyncedPlatformSelected && expanded === "panel1"}
          onChange={() => handleChange("panel1")}
        >
          <Button
            data-testid="select-team-toggle"
            aria-expanded={!isUnsyncedPlatformSelected && expanded === "panel1" ? "true" : "false"}
            aria-controls="panel1d-content"
            // onClick={() => {
            //   if (!isChangingPlatform && hasTeams) {
            //     setExpanded(expanded === "panel1" ? "" : "panel1");
            //   }
            // }}
            onClick={handleSelectTeamButtonClick}
            variant="contained"
            color="info"
            className={styles.buttonSelectTeamName}
            // disabled={!hasTeams || isChangingPlatform}
            disabled={isChangingPlatform || (!hasTeams && teamsData !== null)}
            sx={{
              // cursor: hasTeams && !isChangingPlatform ? "pointer" : "default",
              // Pointer when reconnecting, or when a synced team is selected (header toggles the list).
              cursor: teamsData === null || (partnerMatchesSelectedPlatform && !isUnsyncedPlatformSelected) ? "pointer" : "default",
              "&.Mui-disabled": {
                backgroundColor: "#222222",
                color: "#fff",
                pointerEvents: "none",
              },
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: "60px",
              alignItems: "center",
              position: "relative",
              color: "#bbbbbb",
              py: 0,
              px: 0.5,
            }}
          >
            {isChangingPlatform ? (
              <CircularProgress size={25} disableShrink sx={{ ...stableSpinnerSx, margin: "0 auto" }} />
            ) : (
              <>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", pt: 0 }}>
                  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", }}>
                    {partnerMatchesSelectedPlatform
                      ? // ? selectedPartner
                      mobile || isMobileWebBrowser()
                        ? truncatePlatformName(selectedPartner)
                        : selectedPartner // only for mobile capacitor and web
                      : Array.isArray(teamsData)
                        ? teamsData.length === 0
                          ? "No teams in your account"
                          : "Select Team"
                        : teamsData === null // ← new for yahoo
                          ? "Click to connect again"
                          : // : !teamsData?.leagues || teamsData.leagues.length === 0
                          teamsData && teamsData.leagues?.length === 0 // now null are not going to shown NO TEAMS IN YOUR ACCOUNT ([] does)
                            ? "No teams in your account"
                            : "Select Team"}
                    {!isUnsyncedPlatformSelected &&
                      (Array.isArray(teamsData) ? teamsData.length > 0 : teamsData?.leagues && teamsData.leagues.length > 0) && (
                        <Box component="span" sx={{ display: "flex", alignItems: "center" }}>
                          {expanded === "panel1" ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </Box>
                      )}
                  </Box>
                  {/* Display the last updated timestamp if the user has selected a team */}
                  {partnerMatchesSelectedPlatform && selectedTeamInfo && (
                    // <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: isMobile ? "center" : "space-between", alignItems: isMobile ? "flex-start" : "center", gap: isMobile ? 0 : 1 }}>
                    <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: 1 }}>
                      <Typography variant="h3" sx={{ color: "#bbbbbb", fontSize: "10px", whiteSpace: "nowrap" }}>
                        League Data Updated:
                      </Typography>
                      {/* <Typography variant="h3" sx={{ color: "white", fontSize: "10px" }}>
                     11-17-25
                   </Typography>
                   <Typography variant="h3" sx={{ color: "white", fontSize: "10px" }}>
                     15:05:45
                   </Typography> */}
                      {/* Display the last updated timestamp for the current team */}
                      {getTimestamp()}
                    </Box>
                  )}
                </Box>

                {/* Display History icon — Un-Synced has no history; synced platforms only */}
                {partnerMatchesSelectedPlatform && selectedTeamInfo && isCommonLeagueDataFinished && !isUnsyncedPlatform(selectedTeamInfo.platformId) && (
                  <Tooltip title="League History" arrow placement="bottom">
                    <Button
                      variant="text"
                      disabled={isFetchingHistory}
                      sx={{
                        p: 0,
                        minWidth: "30px",
                        color: showSaveSuccess ? "#36960c" : expanded === "panel2" ? "#bbbbbb" : "#bbbbbb", // if we want frey again, put in the last option "#c1c1c1"
                        position: "absolute",
                        right: `${85 + syncedTeamsPickerCloseOffset}px`,
                        "&.Mui-disabled": {
                          color: "white",
                          opacity: 1,
                          cursor: "not-allowed",
                          pointerEvents: "none",
                        },
                        "&:hover": {
                          color: showSaveSuccess ? "#36960c" : "#bbbbbb",
                        },
                        "&:active": {
                          color: showSaveSuccess ? "#36960c" : "#bbbbbb",
                        },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        // Only open the drawer — fetch already ran on team select
                        setIsHistoryDrawerOpen(true);
                      }}
                    >
                      {isFetchingHistory ? (
                        <CircularProgress size={20} thickness={4} disableShrink sx={stableSpinnerSx} />
                      ) : (
                        <HistoryIcon width={20} height={20} />
                      )}
                    </Button>
                  </Tooltip>
                )}

                {/* Display the button to edit league settings only when commonLeagueData finished successfully */}
                {partnerMatchesSelectedPlatform && selectedTeamInfo && isCommonLeagueDataFinished && (
                  <Tooltip title="League Settings" arrow placement="bottom">
                    <Button
                      variant="text"
                      // disabled={refreshingLeagueData}
                      sx={{
                        p: 0,
                        minWidth: "30px",
                        color: showSaveSuccess ? "#36960c" : expanded === "panel2" ? "#bbbbbb" : "#bbbbbb", // if we want frey again, put in the last option "#c1c1c1"
                        position: "absolute",
                        right: `${42 + syncedTeamsPickerCloseOffset}px`,
                        "&.Mui-disabled": {
                          color: "white",
                          opacity: 1,
                          cursor: "not-allowed",
                          pointerEvents: "none",
                        },
                        "&:hover": {
                          color: showSaveSuccess ? "#36960c" : "#bbbbbb",
                        },
                        "&:active": {
                          color: showSaveSuccess ? "#36960c" : "#bbbbbb",
                        },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleChange(expanded === "panel2" ? "" : "panel2");
                      }}
                    >
                      {showSaveSuccess ? <CheckCircleIcon sx={{ fontSize: 26, color: "#36960c" }} /> : <EditIcon width={20} height={20} />}
                    </Button>
                  </Tooltip>
                )}

                {/* Display the button to refresh league data if the user has selected a team */}
                {partnerMatchesSelectedPlatform && selectedTeamInfo && (
                  <Tooltip title="Refresh League" arrow placement="bottom">
                    <Button
                      variant="text"
                      disabled={refreshingLeagueData}
                      sx={{
                        p: 0,
                        minWidth: "30px",
                        color: "#bbbbbb",
                        position: "absolute",
                        right: `${5 + syncedTeamsPickerCloseOffset}px`,
                        "&.Mui-disabled": {
                          color: "white",
                          opacity: 1,
                          cursor: "not-allowed",
                          pointerEvents: "none",
                        },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRefreshEndpoints();
                      }}
                    >
                      {/* {refreshingLeagueData ?  <SegmentedSpinner/> : <RefreshIcon />}*/}
                      {refreshingLeagueData ? <CircularProgress size={20} thickness={4} disableShrink sx={stableSpinnerSx} /> : <RefreshIcon />}
                    </Button>
                  </Tooltip>
                )}

                {/* Synced only: X opens the platform picker (does not collapse the teams list). Same slot/size/color as refresh. */}
                {/* {!isUnsyncedPlatformSelected && (
                  <Button
                    variant="text"
                    aria-label="open platform picker"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      if (expanded !== "panel0") {
                        handleIconClick();
                      }
                    }}
                    sx={{
                      p: 0,
                      minWidth: "30px",
                      color: "#bbbbbb",
                      position: "absolute",
                      right: "0px",
                      pointerEvents: "auto",
                    }}
                  >
                    <CloseIcon />
                  </Button>
                )} */}
              </>
            )}
          </Button>

          <AccordionDetails
            ref={teamsAccordionDetailsRef}
            sx={{
              padding: 0,
              maxHeight: expanded === "panel1" && !isChangingPlatform ? teamsMaxHeight : "0px",
              overflow:
                expanded === "panel1" && !isChangingPlatform
                  ? mobile
                    ? "hidden"
                    : "auto"
                  : "hidden",
              display: mobile && expanded === "panel1" && !isChangingPlatform ? "flex" : undefined,
              flexDirection: "column",
              // Capacitor: clipper + in-flow scroll child (same pattern as League Settings panel2)
              ...(mobile && expanded === "panel1" && !isChangingPlatform
                ? {
                  position: "relative",
                  touchAction: "pan-y",
                  zIndex: 11,
                }
                : {}),
            }}
            className={styles.accordionDetailTeams}
          >
            {/* {!(isYahooSelected && !validToken) && ( //  */}
            <Box
              sx={
                mobile && expanded === "panel1" && !isChangingPlatform
                  ? {
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    overflowX: "hidden",
                    WebkitOverflowScrolling: "touch",
                    overscrollBehaviorY: "contain",
                    "&::-webkit-scrollbar": { display: "none" },
                    scrollbarWidth: "none",
                  }
                  : { display: "contents" }
              }
            >
              <TeamsDropdown
                ref={teamsHomePageRef}
                teamsData={teamsData}
                handleLeagueId={handleLeagueId}
                handlePartnerSelected={handlePartnerSelected}
                fetchNewsData={fetchNewsData}
                fetchWaiverData={fetchWaiverData}
                fetchWaiverDataStream={fetchWaiverDataStream}
                fetchStartDataStream={fetchStartDataStream}
                fetchRostersData={fetchRostersData}
                fetchRankingsData={fetchRankingsData}
                fetchAllRankingsData={fetchAllRankingsData}
                fetchRundownDataStream={fetchRundownDataStream}
                fetchDraftAdviceDataStream={fetchDraftAdviceDataStream}
                setLoadingNews={setLoadingNews}
                setLoadingWaiver={setLoadingWaiver}
                setLoadingStart={setLoadingStart}
                setLoadingRoster={setLoadingRoster}
                setLoadingRankings={setLoadingRankings}
                setLoadingAllRankings={setLoadingAllRankings}
                setLoadingRundown={setLoadingRundown}
                setLoadingDraftAdvice={setLoadingDraftAdvice}
                isYahooSelected={isYahooSelected}
                yahooToken={yahooToken}
                setHasLoadingStarted={setHasLoadingStarted}
                userDataPlatform={userDataPlatform}
                setMessage={setMessage}
                setSectionData={setSectionData}
                selectedTeams={selectedTeams}
                expanded={expanded}
                setExpanded={setExpanded}
                setEndpointErrors={setEndpointErrors}
                loggingInTo={loggingInTo}
                setLoggingInTo={setLoggingInTo}
                setErrorMessages={setErrorMessages}
                fetchSuperFunctionData={fetchSuperFunctionData}
                setLoadingSuperFunction={setLoadingSuperFunction}
                commonLeagueDataFailed={commonLeagueDataFailed}
                setCommonLeagueDataFailed={setCommonLeagueDataFailed}
                returnedFromBackground={returnedFromBackground}
                setReturnedFromBackground={setReturnedFromBackground}
                setTeamsdata={setTeamsdata}
                setWaiverData={setWaiverData}
                setNewsData={setNewsData}
                setStartData={setStartData}
                setRostersData={setRostersData}
                setRankingsData={setRankingsData}
                setAllRankingsData={setAllRankingsData}
                setRundownData={setRundownData}
                setDraftAdviceData={setDraftAdviceData}
                isHandlingTeamSelection={isHandlingTeamSelection}
                newClickOnPlatofrm={newClickOnPlatofrm}
                setNewClickOnPlatofrm={setNewClickOnPlatofrm}
                setIsChangingPlatform={setIsChangingPlatform}
                setErrorMessageNoDraft={setErrorMessageNoDraft}
                setWaiverStreamState={setWaiverStreamState}
                setStartStreamState={setStartStreamState}
                setRundownStreamState={setRundownStreamState}
                setDraftAdviceStreamState={setDraftAdviceStreamState}
                // validToken={validToken}
                // setValidToken={setValidToken}
                setLoginError={setLoginError}
                setThoughtsCommon={setThoughtsCommon}
                isSuperAnalysisComplete={isSuperAnalysisComplete}
                setIsSuperAnalysisComplete={setIsSuperAnalysisComplete}
                activeRequests={activeRequests}
                setRefreshingLeagueData={setRefreshingLeagueData}
                setLastUpdatedTimestamps={setLastUpdatedTimestamps}
                setEstimatedTimes={setEstimatedTimes}
                calculatorSettings={calculatorSettings}
                setLeagueSettingsChanged={setLeagueSettingsChanged}
                selectedModel={selectedModel}
                userSubscription={userSubscription}
                characterRef={characterRef}
                aiSettings={aiSettings}
                enableCreditValidation={enableCreditValidation}
                setIsBenchDrawerOpen={setIsBenchDrawerOpen}
                setIsPaymentOpen={setIsPaymentOpen}
                setInitialPaymentView={setInitialPaymentView}
                openRateLimitDrawer={openRateLimitDrawer}
              />
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      {/* AUTO-PROCESS AI ONLY FOR PREMIUM USERS (NOT SUBSCRIPTION FREE OR NON LOGGED USERS): when ON, runs waiver/start/rundown/draft streams after Super Analysis (team select or refresh) */}
      {/* {selectedTeamInfo && isLoggedInAuth0ExperienceGlobal && ( */}
      {/* {selectedTeamInfo && userSubscription !== "free" && ( */}
      {/* {selectedTeamInfo && userSubscription !== "free" && isLoggedInAuth0ExperienceGlobal && ( */}
      {/* Un-Synced: hide Run All Agents (blocked agents only) */}
      {/* HIDE RUN ALL AGENTS FOR NOW (IF YOU WANT TO SHOW IT AGAIN, UNCOMMENT THE CODE BELOW 5 LINES. Also in widgetContext.tsx, set autoProcessAI to true in loadUserPreferences (search for this phrase "if you want to make autoProccessAi working again")) */}
      {/* {selectedTeamInfo && !isUnsyncedPlatform(selectedTeamInfo.platformId) && (
        <Box sx={{ px: 0, pt: 0.5 }}>
          <AutoProcessAISwitch userSubscription={userSubscription} />
        </Box>
      )} */}

      {/* League Settings Accordion with backdrop */}
      {selectedTeamInfo && (
        <Box
          ref={leagueSettingsAccordionRef}
          sx={{
            position: "relative",
            width: "100%",
          }}
        >
          {/* Backdrop blur when League Settings is open - only covers area below accordion */}
          {expanded === "panel2" && (
            <Box
              sx={{
                position: "fixed",
                top: `${backdropTop}px`,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(3px)",
                WebkitBackdropFilter: "blur(4px)",
                zIndex: 5,
                pointerEvents: "auto",
              }}
            />
          )}

          <Accordion
            expanded={expanded === "panel2"}
            onChange={() => handleChange("panel2")}
            sx={{
              position: "relative",
              zIndex: expanded === "panel2" ? 10 : 1,
            }}
          >
            <AccordionSummary sx={{ display: "none", minHeight: 0, "&.Mui-expanded": { minHeight: 0 } }} /> {/* This is for the accordion summary to be hidden */}
            <AccordionDetails
              ref={leagueSettingsAccordionDetailsRef}
              sx={{
                border: `0.5px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
                padding: 0,
                maxHeight: expanded === "panel2" ? leagueSettingsMaxHeight : "0px",
                overflow: "hidden",
                display: expanded === "panel2" ? "flex" : "block",
                flexDirection: "column",
                "&::-webkit-scrollbar": {
                  width: "0px",
                  display: "none",
                },
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
              className={styles.accordionDetailTeams}
            >
              <LeagueSettings
                onClose={() => handleChange("")}
                isOpen={expanded === "panel2"}
                commonLeagueData={sectionData?.commonLeagueData}
                onSaveSuccess={handleSaveSuccess}
                onSaveSettings={handleSaveLeagueSettings}
                onResetSettings={handleResetLeagueSettings}
                calculatorSettings={calculatorSettings}
                onOpenKeeperDrawer={() => setIsKeeperDrawerOpen(true)}
                unsyncedLeagueName={unsyncedLeagueNameProp}
                onRenameUnsyncedLeague={onRenameUnsyncedLeagueProp}
              />
            </AccordionDetails>
          </Accordion>
        </Box>
      )}

      {/* Keeper Drawer — key remounts form state per league so values never leak across teams */}
      <KeeperDrawer
        key={selectedTeamInfo ? `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "keeper-drawer"}
        open={isKeeperDrawerOpen}
        onClose={handleKeeperDrawerClose}
        rawNotes={calculatorSettings?.notes ?? sectionData?.commonLeagueData?.league_info?.notes ?? ""}
        leagueType={sectionData?.commonLeagueData?.league_info?.league_type}
        isSubmitting={isKeeperSubmitting}
        onSubmit={handleKeeperSubmit}
      />

      {/* History drawer — menu of endpoints present in user_request_history */}
      <HistoryDrawer
        open={isHistoryDrawerOpen}
        onClose={() => setIsHistoryDrawerOpen(false)}
        items={historyItems}
      />
    </>
  );
};

export default LeagueSelector;
